var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tableau"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"statistiques_agence visiteurs mb-5"},[_c('canvas',{staticStyle:{"max-width":"800px","margin":"auto"},attrs:{"id":"bar-chart"}})])])])])
}]

export { render, staticRenderFns }